module.exports = __webpack_public_path__ + "static/img/MattTurner.7e08dbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MattTurner.jpg
// module id = HgR1
// module chunks = 0